// Centralized API URL constants — single source of truth for all Supabase endpoints

const _supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const _anonKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined;

// Fail loudly at module load if env vars are missing or empty
if (!_supabaseUrl) {
  console.error("[constants] VITE_SUPABASE_URL is missing or empty — API calls will fail");
}
if (!_anonKey) {
  console.error("[constants] VITE_SUPABASE_PUBLISHABLE_KEY is missing or empty — API calls will fail");
}

// FIX #99: validate VITE_SUPABASE_URL at module load to prevent sending data to tampered endpoints
if (_supabaseUrl && !/^https:\/\/[a-z0-9-]+\.supabase\.co$/i.test(_supabaseUrl)) {
  console.error("[Security] VITE_SUPABASE_URL does not match expected Supabase pattern:", _supabaseUrl);
}

export const SUPABASE_URL = _supabaseUrl ?? "";
export const ANON_KEY = _anonKey ?? "";

export const CHAT_URL = `${SUPABASE_URL}/functions/v1/chat`;
export const AGENT_URL = `${SUPABASE_URL}/functions/v1/ai-agent`;

const _projectId = import.meta.env.VITE_SUPABASE_PROJECT_ID as string | undefined;
if (!_projectId) {
  console.error("[constants] VITE_SUPABASE_PROJECT_ID is missing or empty — auth session management will fail");
}
export const SUPABASE_PROJECT_ID = _projectId ?? "";

export const TURNSTILE_SITE_KEY = (import.meta.env.VITE_TURNSTILE_SITE_KEY ?? "") as string;

// Shared durations
/** Default React Query staleTime for server data that tolerates ~30s of staleness */
export const QUERY_STALE_TIME_MS = 30_000;
/** Refresh the auth token when it expires within this window */
export const TOKEN_REFRESH_WINDOW_MS = 60_000;

// Agent model ids and the provider-grouped model list — defined in ./models
// (no env access there, so tests can import it).
export {
  CLAUDE_HAIKU_MODEL_ID,
  CLAUDE_SONNET_MODEL_ID,
  CLAUDE_OPUS_MODEL_ID,
  DEFAULT_AGENT_MODEL_ID,
  AGENT_MODEL_GROUPS,
  AGENT_MODELS,
  normalizeModelId,
  getAgentModel,
} from "./models";
export type { AgentModelOption, AgentModelGroup, ModelProviderGroup } from "./models";
